import { useEffect, RefObject, useMemo } from 'react';

import { KeycloakData } from '@zooplus/checkout-state';

import { TARGET_ACTION_ID } from '@utilities/constants';
import { configureLinkElements } from '@utilities/utils';

type LinkConfig = {
  className: string;
  actionId: TARGET_ACTION_ID;
  url?: string;
};

export const useLoginRegisterLinkHandler = (
  containerRef: RefObject<HTMLElement>,
  onCustomerClick: (actionId: TARGET_ACTION_ID) => void,
  keycloakData?: KeycloakData,
) => {
  const keycloakLoginUrl = keycloakData?.keycloakLoginUrl;
  const keycloakRegistrationUrl = keycloakData?.keycloakRegistrationUrl;

  const linkConfigs: LinkConfig[] = useMemo(
    () => [
      {
        className: 'register',
        actionId: TARGET_ACTION_ID.CREATE_ACCOUNT_FROM_GUEST,
        url: keycloakRegistrationUrl,
      },
      {
        className: 'login',
        actionId: TARGET_ACTION_ID.SIGN_IN_FROM_GUEST,
        url: keycloakLoginUrl,
      },
    ],
    [keycloakRegistrationUrl, keycloakLoginUrl],
  );

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const attachLinkHandlers = linkConfigs.map(({ className, actionId, url }) => {
      const links = Array.from(container.querySelectorAll(`a.${className}`)) as HTMLAnchorElement[];

      return configureLinkElements(links, () => onCustomerClick(actionId), url);
    });

    return () => attachLinkHandlers.forEach((cleanup) => cleanup());
  }, [containerRef, linkConfigs, onCustomerClick]);
};
